var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.613 15.613L21.6665 21.6665",
    stroke: "#B2B2B2",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 17.3335C14.4233 17.3335 17.3335 14.4233 17.3335 10.8335C17.3335 7.24365 14.4233 4.3335 10.8335 4.3335C7.24365 4.3335 4.3335 7.24365 4.3335 10.8335C4.3335 14.4233 7.24365 17.3335 10.8335 17.3335Z",
    stroke: "#B2B2B2",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.61972511e2460af015f015f47ba04a48.svg";
export { ForwardRef as ReactComponent };